<template>
  <div>
    <router-view />

    <ActionRequiredModal ref="action-required-modal" />
  </div>
</template>

<script>
import ValidationMixin from '@/mixins/ValidationMixin.vue'
import { SET_MAP_OPTIONS } from '@/constants/store-types'
import ActionRequiredModal from '@/components/account/ActionRequiredModal.vue'

export default {
  name: 'App',
  mixins: [ValidationMixin],
  components: {
    ActionRequiredModal
  },
  metaInfo() {
    return {
      title: this.$title,
      titleTemplate: `%s | ${this.$t('branding.appName')}`,
      htmlAttrs: {
        dir: this.$t('direction')
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('branding.appTagline')
        }
      ]
    }
  },
  mounted() {
    this.getSetting()
    this.showModal()
  },
  methods: {
    getSetting() {
      this.$api.setting.get().then((response) => {
        this.$store.commit(SET_MAP_OPTIONS, response.mapOptions)
      })
    },
    showModal() {
      this.$api.driverAccount.loginStatus().then((response) => {
        if (!response.contractConfirmed)
          this.$refs['action-required-modal'].show()
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/index.scss';
</style>
